import React from "react";
import {User} from "models/User";
import {Link} from "react-router-dom";
import { Badge, Col, Row } from "reactstrap";
import { useOfficeTranslation } from "i18n/OfficeTranslation";

interface Props {
    users: User[];
}

interface Actions {

}

const UserProfilesTable: React.FC<Actions & Props> = ({ users }) => {
    const { t } = useOfficeTranslation();

    if (users.length === 0) {
        return <p className="text-muted text-center mt-3 mb-0">{t("user.userProfilesTable.noUsersFound")}</p>;
    }

    return (
        <div>
            {users.map(user => (
                <Link
                    className="d-block text-body text-decoration-none border-bottom py-3"
                    key={user.id}
                    to={`/users/${user.id}`}
                >
                    <Row className="align-items-center g-3">
                        <Col md={4}>
                            <strong>{user.name}</strong>
                            <span className="d-block text-muted mt-1">{user.email}</span>
                        </Col>
                        <Col md={3}>
                            <small className="d-block text-muted">{t("user.userProfilesTable.access")}</small>
                            <span>{user.accounts?.length ?? 0} {t("user.userProfilesTable.accounts")}</span>
                        </Col>
                        <Col md={2}>
                            <Badge color={user.activated ? "success" : "danger"} pill>
                                {t(user.activated ? "common.status.active" : "common.status.inactive")}
                            </Badge>
                        </Col>
                        <Col md={2}>
                            <small className="d-block text-muted">{t("common.region")}</small>
                            <span>{user.region || "—"}</span>
                        </Col>
                        <Col className="text-end" md={1}>
                            <i className="mdi mdi-chevron-right text-muted font-size-18" />
                        </Col>
                    </Row>
                </Link>
            ))}
        </div>
    );
};

export default UserProfilesTable;
